import { render, staticRenderFns } from "./OtherSocialServices.vue?vue&type=template&id=21d2a80a"
import script from "./OtherSocialServices.vue?vue&type=script&lang=js"
export * from "./OtherSocialServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports